import { useEffect } from 'react'

import { createFileRoute, useNavigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_event/bonus/$uid')({
  component: DigitalProductBonusRedirectPage
})

function DigitalProductBonusRedirectPage() {
  const navigate = useNavigate()

  useEffect(() => {
    void navigate({ to: '/', replace: true })
  }, [navigate])

  return null
}
